import React from 'react';

export default function ProductLinkCell({ name, path }) {
  if (!name || !path) return null;
  return <a href={path}>{name}</a>;
}
